export const EYE_ITEM_DEF_ID = '019875db-9aff-779c-b15e-325a3c261619'
